import { analytics } from './../firebase';
import { isLocalhost } from './CommonUtiliy';

export const logEvent = (event, data) => {
    if (!isLocalhost()) {
        analytics.logEvent(event, data);
    }
}